export default __webpack_public_path__ + "static/media/modal_img.6e9fc68d.png";